import { GroupByOptions, ProjectSortByOptions } from '@awork/_shared/models/group-by-options.model'
import type { SortByOption } from '@awork/_shared/models/sort-by-option.model'
import type { GridUserSettings } from '@awork/framework/state/settings.types'
import type { CollapsedEntities } from '@awork/framework/models/view-setting.model'

export type QuickFilter = 'all' | 'my' | 'progress' | 'closed'

export interface ProjectPageSettings extends Omit<GridUserSettings<string>, 'sortBy'> {
  view?: 'list' | 'timeline'
  selectedDraftId?: string
  quickFilter?: QuickFilter
  selectedFilterName?: string
  groupBy?: GroupByOptions
  collapsedGroupsByGrouping?: Partial<Record<GroupByOptions, CollapsedEntities>>
  sortBy?: SortByOption<ProjectSortByOptions>
  groupingCustomFieldId?: string
  sortingCustomFieldId?: string
  collapsedGroupsByCustomField?: Record<string, CollapsedEntities>
  sidebarExpanded?: boolean
  sidebarWidth?: number
  showMilestones?: boolean
  timelineZoomLevelStep?: number
}

export const defaultProjectPageSettings: ProjectPageSettings = {
  groupBy: GroupByOptions.none,
  sortBy: { value: ProjectSortByOptions.default, orderBy: 'asc' },
  gridColumnSettings: [
    { id: 'name', width: 300, visible: true },
    { id: 'client', width: 140, visible: false },
    { id: 'type', width: 110, visible: true },
    { id: 'teams', width: 140, visible: false },
    { id: 'tags', width: 140, visible: true },
    { id: 'startDate', width: 80, visible: false },
    { id: 'dueOn', width: 80, visible: true },
    { id: 'trackedHours', width: 80, visible: false },
    { id: 'time', width: 80, visible: false },
    { id: 'budget', width: 80, visible: false },
    { id: 'tasks', width: 80, visible: true },
    { id: 'progress', width: 100, visible: true },
    { id: 'lead', width: 110, visible: true },
    { id: 'creator', width: 140, visible: false },
    { id: 'members', width: 110, visible: false },
    { id: 'status', width: 110, visible: true },
    { id: 'statusType', width: 100, visible: false },
    { id: 'dueWeek', width: 100, visible: false },
    { id: 'dueMonth', width: 100, visible: false }
  ]
}

export const defaultaworkAIProjectPageSettings: ProjectPageSettings = {
  groupBy: GroupByOptions.none,
  sortBy: { value: ProjectSortByOptions.name, orderBy: 'asc' },
  gridColumnSettings: [
    { id: 'name', width: 300, visible: true, order: 0 },
    { id: 'members', width: 110, visible: true, order: 1 },
    { id: 'status', width: 110, visible: true, order: 2 },
    { id: 'createdOn', width: 80, visible: false, order: 3 },
    { id: 'creator', width: 140, visible: false, order: 4 },
    { id: 'teams', width: 140, visible: false, order: 5 }
  ]
}
